<template>
<div>
    <Uon :claim_id="route.query.claim_id"  />
</div>
</template>

<script setup>
import Uon from '@/comp/Uon/Uon.vue'
import {ref, watch} from 'vue'
import { useRouter, useRoute } from 'vue-router/composables'

const route = useRoute()

</script>